const workflow: any = {
  module: 'workflow',
  dashboard: 'workflow:dashboard',
};

export default workflow;